import { Navigate, useLocation } from "react-router-dom";
import { getProductByLegacyPath } from "../data/products";

// Legacy URLs (/products/scissor-lift-hanger, /products/boom-lift-hanger) permanently point to the canonical product pages.
const ProductPage = () => {
  const { pathname } = useLocation();
  const product = getProductByLegacyPath(pathname.replace(/\/$/, ""));
  return <Navigate to={product ? product.to : "/#products"} replace />;
};

export default ProductPage;
